import React from 'react';
import { useHistory } from 'react-router-dom';

import { SVGIcon } from '@uikit/old/Icon/Icon';
import { authService } from 'src/services/authService';
import { useQueryClient } from 'react-query';
import queryCacheKeysConstants from '@constants/queryCacheKeys.constants';

function LogoutButton({ color }: { color?: string }): JSX.Element {
  const history = useHistory();
  const queryClient = useQueryClient();

  const handleLogout = (e) => {
    e.stopPropagation();

    authService.logout(history).then(() => {
      queryClient.removeQueries(queryCacheKeysConstants.userProfile);
    });
  };

  return (
    <div
      className="sidebar-footer__profile-logout-button"
      data-testid="sidebar-logout"
      onClick={handleLogout}
      role="button"
      tabIndex={0}
    >
      <SVGIcon icon="logout" color={color} />
    </div>
  );
}

export default LogoutButton;
